<template>
  <div class="off-store-wrap">
    <div class="page-header">
      <div class="flex-row-between-center title-top">
        <div class="flex-row-start-center">
          <div class="title-left">
            当前店铺状态：
            <span class="status-tag">{{ currentStatus }}</span>
          </div>
          <div class="">
            <span class="el-icon-warning c-red"></span>
            请注意：商家提交休店申请后，需平台审核通过才生效。平台审核时效：
            <span class="c-red">1个工作日</span>
          </div>
        </div>
        <div
          class="apply-btn"
          @click="applyOffStore"
          v-show="currentStatus == '营业中'"
        >
          申请休店
        </div>
      </div>
      <div class="top-img">
        <img
          :src="currentStatus == '营业中' ? img.shopOpen : img.shopClose"
          :width="60"
          alt=""
        />
      </div>
    </div>
    <div class="gray-bg"></div>
    <el-form
      ref="searchForm"
      label-position="right"
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      style="margin-bottom: 10px"
    >
      <el-form-item label="休店原因">
        <el-select
          v-model="searchForm.reason"
          clearable
          multiple
          placeholder="请选择"
        >
          <el-option
            v-for="item in reasonList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          v-model="searchForm.status"
          clearable
          multiple
          placeholder="请选择"
        >
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="getList()"
          >查询</el-button
        >
        <el-button
          type="primary"
          size="small"
          style="background:#fff;color:#FF6224;border-color:#ccc;color:#666;"
          @click="resetForm"
          >重置
        </el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%; text-align: center"
        size="mini"
      >
        <el-table-column prop="id" label="申请单号" width="100" />
        <el-table-column prop="content" label="申请内容" width="180">
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{ scope.row.rest_type_str }}
            </div>
            <div style="text-align: left;">{{ scope.row.content }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="reason_str" label="休店原因" width="180" />
        <el-table-column prop="detailed_reason" label="详细原因" />
        <el-table-column prop="created_at" label="发起时间" width="150" />
        <el-table-column prop="review_time" label="审核时间" width="150" />
        <el-table-column prop="applicant_name" label="申请人" />
        <el-table-column prop="status_str" label="状态" />
        <el-table-column prop="review_comment" label="审批备注" />
      </el-table>
    </div>
    <el-pagination
      style="text-align: center"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="queryInfo.current"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="queryInfo.page_size"
      layout="total,sizes, prev, pager, next,jumper"
      :total="queryInfo.total"
    >
    </el-pagination>
    <!-- 休店弹框 -->
    <el-dialog
      custom-class="off-store-dialog"
      title="申请休店"
      append-to-body
      center
      :visible.sync="visible"
      width="660px"
      @close="hideDialog"
      :destroy-on-close="true"
    >
      <el-form
        :model="addForm"
        :rules="rules"
        ref="addForm"
        label-width="100px"
        class="off-store-form"
      >
        <el-form-item label="休店原因" prop="reason">
          <el-select
            v-model="addForm.reason"
            clearable
            placeholder="请选择休店原因"
            style="width: 360px;"
          >
            <el-option
              v-for="item in reasonList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
              style="width: 360px;"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="休店类别" prop="type" style="margin-bottom: 20px;">
          <el-checkbox-group v-model="addForm.type">
            <el-checkbox label="休店" name="type"></el-checkbox>
          </el-checkbox-group>
          <div class="checked-tips">
            <span class="el-icon-warning-outline c-red"></span>
            <span style="font-size: 12px;"
              >客户正常下单，商家订单履约时效延长，最长休店时间是15天</span
            >
          </div>
        </el-form-item>
        <el-form-item label="详细原因" prop="detailed_reason">
          <el-input
            type="textarea"
            v-model="addForm.detailed_reason"
            placeholder="请输入详细原因，最多不超过20个字"
            maxlength="20"
            show-word-limit
            style="width: 360px;"
          ></el-input>
        </el-form-item>
        <el-form-item prop="startDay" label="开始日期">
          <el-date-picker
            v-model="addForm.startDay"
            type="date"
            placeholder="选择日期"
            style="width: 360px;"
            :pickerOptions="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="endDay" label="结束日期">
          <el-date-picker
            v-model="addForm.endDay"
            type="date"
            placeholder="选择日期"
            style="width: 360px;"
            :pickerOptions="pickerOptions2"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="visible = false">取消</el-button>
          <el-button type="primary" @click="submitForm('addForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOffList,
  getReasonEnum,
  postOffStore,
  getCurrentStatus
} from "@/models/orderReportModel";
import shopOpen from "@/assets/img/report/shop-open.png";
import shopClose from "@/assets/img/report/shop-close.png";
import moment from "moment";
export default {
  data() {
    return {
      img: { shopOpen, shopClose },
      queryInfo: {
        page: 1,
        page_size: 10,
        current: 1, // 当前页
        total: 0 //总数
      }, // 分页配置数据
      searchForm: {
        reason: [],
        status: [],
        page: 1,
        page_size: 10
      },
      addForm: {
        reason: undefined,
        type: ["休店"],
        detailed_reason: undefined,
        startDay: undefined,
        endDay: undefined
      },
      tableData: [], // 表格数据
      loading: true,
      currentStatus: "",
      visible: false, //休店弹框
      reasonList: [],
      statusList: [
        { value: 2, label: "待审核" },
        { value: 3, label: "审核通过" },
        { value: -1, label: "审核驳回" }
      ],
      rules: {
        reason: [
          { required: true, message: "请选择休店原因", trigger: "change" }
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请选择休店类型",
            trigger: "change"
          }
        ],
        startDay: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        endDay: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ]
      },
      pickerOptions: {
        disabledDate(current) {
          return current && current < moment().endOf("day");
        }
      },
      pickerOptions2: {
        disabledDate(current) {
          return current && current < moment().add(1, "day");
        }
      }
    };
  },
  created() {
    this.getList(); //获取列表
    this.getEnum();
    this.getStatus();
  },
  methods: {
    // 原因枚举
    getEnum() {
      getReasonEnum()
        .then(res => {
          let arr = [];
          if (res) {
            for (const key in res) {
              if (Object.hasOwnProperty.call(res, key)) {
                arr.push({ label: res[key], value: key });
              }
            }
            this.reasonList = arr;
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    // 当前店铺状态
    getStatus() {
      getCurrentStatus()
        .then(res => {
          if (res) {
            this.currentStatus = res.rest_status || "";
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    //获取列表
    getList(param) {
      const searchParams = param || this.searchForm;
      const params = {
        ...searchParams,
        reason:
          searchParams.reason.length > 0
            ? searchParams.reason.join(",")
            : undefined,
        status:
          searchParams.status.length > 0
            ? searchParams.status.join(",")
            : undefined,
        page: searchParams.page || this.queryInfo.page || 1,
        page_size: searchParams.page_size || this.queryInfo.page_size || 10
      };
      getOffList(params)
        .then(res => {
          this.loading = false;
          this.tableData = res.list || []; // 获取数据
          this.queryInfo.total = res.total;
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.message);
        });
    },
    // 重置
    resetForm() {
      const params = {
        reason: [],
        status: [],
        page: 1,
        page_size: 10
      };
      this.searchForm = params;

      this.queryInfo = {
        ...this.queryInfo,
        page: 1,
        page_size: 10
      };
      this.getList(params);
    },

    // 改变pagesize
    handleSizeChange(value) {
      this.queryInfo.page_size = value;
      this.searchForm.page_size = value;
      const params = { ...this.searchForm, page_size: value };
      this.getList(params);
    },
    // 改变page
    handleCurrentChange(value) {
      this.queryInfo.page = value;
      this.searchForm.page = value;
      const params = { ...this.searchForm, page: value };
      this.getList(params);
    },
    // 申请休店
    applyOffStore() {
      this.visible = true;
    },
    // 关闭休店弹框
    hideDialog() {
      this.visible = false;
      this.$refs["addForm"].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.onConfirm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onConfirm() {
      const { endDay, startDay } = this.addForm;
      const days = moment(endDay).diff(moment(startDay), "days");
      if (days <= 0) {
        this.$message.warning("结束日期必须大于开始日期！");
        return false;
      }
      if (days > 15) {
        this.$message.warning("休店天数不能超过15天！");
        return false;
      }
      // if(new Date(endDay))
      this.$confirm("确定要提交申请吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false
      })
        .then(() => {
          this.offShop();
        })
        .catch(() => {});
    },
    offShop() {
      const { reason, detailed_reason, endDay, startDay } = this.addForm;
      const params = {
        reason,
        type: 1, // 1-休店（暂时只有一种类型）
        is_submit: 1, //提交操作
        detailed_reason,
        start_day: moment(startDay).format("YYYY-MM-DD"),
        end_day: moment(endDay).format("YYYY-MM-DD")
      };
      // console.log("params：", params);
      postOffStore(params)
        .then(res => {
          this.getList();
          this.hideDialog();
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    }
  }
};
</script>
<style lang="scss">
.off-store-wrap {
  .page-header {
    margin: 8px 0 30px;
    font-size: 14px;
    .title-left {
      font-size: 16px;
      font-weight: bold;
      display: flex;
    }
    .title-top {
      border-bottom: 1px solid #eee;
      padding-bottom: 8px;
    }
  }
  .gray-bg {
    position: absolute;
    width: 100%;
    height: 14px;
    left: 0;
    background: #eee;
    top: 130px;
  }
  .apply-btn {
    border: 1px solid #ff6224;
    padding: 3px 12px;
    font-size: 13px;
    border-radius: 4px;
    color: #ff6224;
    margin-left: 24px;
    cursor: pointer;
  }
  .m-b-8 {
    margin-bottom: 8px;
  }
  .c-red {
    color: #ff4d4f;
  }
  .status-tag {
    border: 1px solid #6ee6b2;
    background-color: #e6fff2;
    color: #00be7e;
    padding: 2px 8px;
    margin-right: 40px;
    font-size: 12px;
    font-weight: normal;
    &.close {
      border: 1px solid rgba(0, 0, 0, 0.15);
      background-color: rgba(0, 0, 0, 0.04);
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .top-img {
    text-align: center;
    margin: 14px auto;
  }
}
.off-store-form .el-form-item {
  margin-bottom: 10px;

  .c-red {
    color: #ff4d4f;
  }
}
.off-store-dialog {
  .el-form-item__label {
    text-align: right !important;
  }
  .checked-tips {
    position: absolute;
    top: 0;
    left: 64px;
  }
}
/deep/.el-table tr {
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderReport/offStore.vue